import _ from 'lodash';
import classNames from 'classnames';
import { ResponsiveProps } from '..';
import { useCallback, useEffect, useRef } from 'react';
import { CaseOption } from '../../ParallelCase';

const Web = (props: ResponsiveProps) => {
  const {
    isShowAddCaseHoverMessage,
    cases,
    renderAddCaseButton,
    children,
    renderHoverMessage,
    renderCaseIcon,
    activeCaseIndex,
    onChangeActiveCaseIndex,
  } = props;

  const lastItemRef = useRef<HTMLDivElement>(null);

  const renderCaseIndex = useCallback(
    (_: CaseOption, idx: number) => {
      const labelClassName = classNames('nav-item', { active: idx === activeCaseIndex });

      return (
        <div
          ref={idx === cases.length - 1 ? lastItemRef : null}
          className={labelClassName}
          key={idx}
          onClick={() => onChangeActiveCaseIndex(idx)}
        >
          <span className="nav-link">Case {idx + 1}</span>
          {renderCaseIcon(idx)}
        </div>
      );
    },
    [activeCaseIndex, onChangeActiveCaseIndex, renderCaseIcon, cases.length]
  );

  useEffect(() => {
    if (lastItemRef.current) {
      lastItemRef.current.scrollIntoView({
        behavior: 'smooth',
        inline: 'end',
        block: 'nearest',
      });
    }
  }, [cases.length]);

  return (
    <div className="add-case-web">
      <div className="nav nav-tabs">
        <div className="d-flex nav-items-wrap case-index__container">{_.map(cases, renderCaseIndex)}</div>
        {isShowAddCaseHoverMessage ? renderHoverMessage : renderAddCaseButton}
      </div>
      <div className={`add-case-card`}>{children}</div>
    </div>
  );
};

export default Web;
